import React, { ReactNode, useEffect } from 'react'

import { Editor as TextEditor } from '@tinymce/tinymce-react'
import { useField, useFormikContext } from 'formik'

import Label from '../components/Label'
import FieldProps from './FieldProps'
import Error from './FormItemError'

export interface HtmlEditorProps extends FieldProps {
  hint?: string
  initialValue?: string
  value?: string
  height?: number
  disabled?: boolean
}

const FormikHtmlEditorField: React.FC<HtmlEditorProps> = (props) => {
  const [field, meta] = useField(props)
  const context = useFormikContext()
  const showError = meta.touched && meta.error

  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>

  const id = props.id || props.name

  const handleEditorChange = (e: any) => {
    context.setFieldValue(props.name, e.target.getContent())
  }

  useEffect(() => {
    context.setFieldValue(props.name, props.value)
  }, [props.value])

  const handleEditorBlur = () => {
    context.setFieldTouched(props.name, true)
  }

  return (
    <>
      <Label htmlFor={id} className=" no-select hand-on-hover">
        {props.label}
        {props.hint}
      </Label>

      <TextEditor
        apiKey="isjqpkfryeci65mningt7lnuzbe7f8xsxi2wrwptpmnl327a"
        initialValue={props.value}
        onChange={handleEditorChange}
        onBlur={handleEditorBlur}
        disabled={props.disabled}
        init={{
          disabled: props.disabled,
          height: props.height ?? 300,
          width: '100%',
          plugins:
            'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
          menubar: 'file edit view insert format tools table tc help',
          toolbar:
            'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
          image_advtab: true,
          image_caption: true,
          quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        }}
      />
      {error}
    </>
  )
}
export { FormikHtmlEditorField as HtmlEditor }
export default FormikHtmlEditorField
